import { createFileRoute } from '@tanstack/react-router'
import { FleetSection } from '@ufc/domains/assets'

export const Route = createFileRoute('/fleet/drivers')({
  component: FleetDriversPage,
})

function FleetDriversPage() {
  return <FleetSection activeTab="drivers" />
}
